// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/blocks/list-widget.scss
// module id = 1071
// module chunks = 65